import angular from 'angular';
import contextProvider from './context.provider';


const activityLogService = angular.module('ttb.services.activityLog.service', [
  contextProvider,
])
  .factory('activityLogService', ['$q', '$http', 'durationService', 'context',
    ($q, $http, durationService, context) => {
      const toModel = (response) => {
        if (DEBUG) {
          console.log(response);
        }

        const activity = response.data;

        const userWorkingConfig = activity.userWorkingConfig;
        const comment = activity.comment;
        const isActive = activity.isActive;

        const teamId = activity.teamId;
        const issueId = activity.issueId;
        const issueType = activity.issueType;
        const parentItemType = activity.parentItemType;
        const activityStatus = activity.activityStatus;
        const activitySubItems = activity.activitySubItems;
        const assignedTo = activity.assignedTo;
        const isReadOnly = activity.isReadOnly;
        const categoryId = activity.categoryId;

        const durationMinutes = activity.durationMinutes;
        const childDurationMinutes = activity.childDurationMinutes;
        const days = activity.days;
        const availableSprints = activity.availableSprints;
        const sprintId = activity.sprintId;
        const availableUsers = activity.availableUsers;
        const priorityId = activity.priorityId;
        const createdDate = activity.createdDate;

      
        const startTime = new Date(activity.startTime);
        const endTime = new Date(activity.endTime);
        const projectItemTypeConfigId = activity.projectItemTypeConfigId;

        return {
          startTime,
          endTime,
          comment,
          isActive,
          durationMinutes,
          days,
          userWorkingConfig,
          teamId,
          issueId,
          issueType,
          parentItemType,
          activityStatus,
          childDurationMinutes,
          activitySubItems,
          assignedTo,
          isReadOnly,
          categoryId,
          availableSprints,
          sprintId,
          availableUsers,
          priorityId,
          createdDate,
          projectItemTypeConfigId
        };
      };

      const getActivityLog = (id, teamId) => $q((resolve, reject) => {
        context.getProject()
          .then((project) => {
            $http.get(`/api/activity-log/${project.group}/${project.name}/`, { params: { id, teamId } })
              .then((data) => {
                resolve(toModel(data));
              }, reject);
          }, reject);
      });

      function upsetActivityLog({ activityLogId, issueId, startTime, endTime, comment, durationMinutes, days, selectedSprint, assignedTo }) {
        return $q((resolve, reject) => {
          context.getProject()
            .then((project) => {
              $http.post(`/api/activity-log/${project.group}/${project.name}/`,
                {
                  activityLogId,
                  issueId,
                  startTime,
                  endTime,
                  comment,
                  durationMinutes,
                  days,
                  sprintId: selectedSprint ? selectedSprint.id : null,
                  assignedTo
                })
                .then((response) => {
                  resolve(response.data);
                }, reject);
            }, reject);
        });
      }

      return {
        getActivityLog,
        upsetActivityLog,
      };
    }])
  .name;

export default activityLogService;



// WEBPACK FOOTER //
// ../services/activity-log.service.js